import { Component, Input } from "@angular/core";

declare const ApexCharts: any;

@Component({
    selector: 'apex-bar-chart-basic',
    template: `
    <div id="{{elemId}}"></div>
    `
})

export class ApexBarChartBasic {
    @Input() labels = '';
    @Input() values = [];
    @Input() toolbarShow = false;
    @Input() height = 300;
    @Input() colors = ['#2b908f', '#f9a3a4', '#90ee7e', '#b84644', '#4576b5', '#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B',
        '#f48024', '#69d2e7'];
    public elemId = 'apex-bar-chart-basic-' + Math.round(Math.random() * 10000);
    constructor() {

    }

    ngOnInit() {

        setTimeout(() => {
            this.loadChart();
        }, 1000);
    }

    loadChart() {


        const options = {
            colors: this.colors,
            series: [{
                data: this.values, //[400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380]
            }],
            chart: {
                toolbar: {
                    show: this.toolbarShow
                },
                type: 'bar',
                height: this.height,
                animations: {
                    enabled: true,
                    easing: "linear",
                    dynamicAnimation: {
                        speed: 1000
                    }
                },
            },
            plotOptions: {
                bar: {
                    borderRadius: 4,
                    horizontal: true,
                    distributed: true
                }
            },



            dataLabels: {
                enabled: false,
                style: {
                    colors: ['#fff']
                }
            },


            stroke: {
                width: 1,
                colors: ['#fff']
            },

            xaxis: {
                categories: this.labels,
                //['South Korea', 'Canada', 'United Kingdom', 'Netherlands', 'Italy', 'France', 'Japan',
                //   'United States', 'China', 'Germany'
                // ],
            }
        };

        var chart = new ApexCharts(document.querySelector("#" + this.elemId), options);
        chart.render();
    }

}